;(function () {
  "use strict";

  try {
    require('intersection-observer');
    var quicklink = require('quicklink/dist/quicklink.js');
    quicklink({
      ignores: [
        /cart.js/,
        /\/cart\/\/?/,
        function (uri) {
          return uri.includes('/account');
        }
      ]
    });
  } catch(err) {
    console.log('error launching quicklink');
    console.log(err);
  }

  /* Globals */
  window.jQuery = window.$ = require('jquery');
  window.Cookies = require('js-cookie');
  require('jquery-touch-events');
  require('imagesloaded');

  window._ = require('underscore');
  window.Backbone = require('backbone');
  window.imagesLoaded = require('imagesloaded');
  window.Q = require('Q');
  window.App = {};

  window.App.touch = (function () {
    return 'ontouchstart' in window        // works on most browsers 
        || navigator.maxTouchPoints;       // works on IE10/11 and Surface
  }());

  App.guid = (function () {
    function s4() {
      return Math.floor((1 + Math.random()) * 0x10000)
                 .toString(16)
                 .substring(1);
    }
    return function() {
      return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
             s4() + '-' + s4() + s4() + s4();
    };
  }());

  /* Global Events Delegator */
  window.App.Events = {};
  _.extend(window.App.Events, Backbone.Events);

  var HeaderView = require('./views/header');
  var FooterView = require('./views/footer');
  var ImageSliderView = require('./views/slider');
  var TabsView = require('./views/tabs');
  // var VerticalTabsView = require('./views/vertical-tabs');
  var NewsletterFormView = require('./views/newsletter-form');
  var MiniCartView = require('./views/mini-cart');
  var LazyLoadView = require('./views/lazy-load');
  var EmailSignupModal = require('./views/email-signup-modal');

  /* Switch this to bulkify or something */
  var Pages = {
    'index': require('./pages/index'),
    'product': require('./pages/product'),
    'customers-login': require('./pages/customers-login'),
    'cart': require('./pages/cart'),
    '404': require('./pages/not-found'),
    'collection': require('./pages/collection'),
    'search': require('./pages/search'),
    'customers-addresses': require('./pages/customers-addresses'),
    'customers-account': require('./pages/customers-account'),
    'blog': require('./pages/blog'),
    'article': require('./pages/article'),
    'page-giving-back': require('./pages/giving-back'),
    'page-gift-advisor': require('./pages/gift-advisor'),
    'page-contact-us': require('./pages/contact-us'),
    'page-resources': require('./pages/resources')
  };

  var PageView = Pages[$('#page').attr('value')];

  $(document).ready(function () {
    new HeaderView({el: $('header.site-header') });
    new FooterView({el: $('footer.site-footer') });

    window.App.mcv = new MiniCartView({el: $('.mini-cart') });
    // $('.image-slider').each(function () {
    //   new ImageSliderView({el: this});
    // });

    $('form.newsletter-form').each(function () {
      new NewsletterFormView({el: this});
    });

    $('.tabs').each(function () {
      new TabsView({el: this});
    });

    // $('.vertical-tabs').each(function () {
    //   new VerticalTabsView({el: this});
    // });


    if (PageView) {
      new PageView({ el: $('body') });
    }

    // if (!window.Cookies.get('repeat_customer_twoday') && !window.Cookies.get('submitted_email')) {
    //   setTimeout(function () {
    //     new EmailSignupModal();

    //     setTimeout(function () {
    //       /* allow time to engage */
    //       window.Cookies.set('repeat_customer_twoday', 'true', { expires: 2 });
    //     }, 1000);
    //   }, 4 * 1000);
    // }
  });

  $(window).load(function () {
    $(window).trigger('resize');
  });

  $('.lazy-load').each(function () {
    new LazyLoadView({el: this});
  });

  function addToCart($el, id, qty, title) {
    if (window.loading) {
      console.log('currently loading request. Waiting');
      return false;
    }

    var success = function (d) {
      window.loading = false;
      window.App.mcv.render();
      $el.addClass('success');
      setTimeout(function () {
        $el.removeClass('success');
      }, 1000); 

      notify('"'+title+'" was added to your bag!');
    };

    var error = function (d) {
      window.loading = false;

      var json = d.responseJSON || {};
      if (json.description) {
        notify(json.description);
      }
    };

    var params = {
      type: 'POST',
      url: '/cart/add.js',
      data: { id: id, qty: qty },
      dataType: 'json',
      success: success,
      error: error
    };

    // this.$addToCartButtons.addClass('loading');
    window.loading = true;
    $.ajax(params);
  }

  function notify(msg) {
    var $alert = $('<div id="notification">'+msg+'</div>');

    $('body').append($alert);
    setTimeout(function () {
      $alert.addClass('visible');
    }, 10);

    setTimeout(function () {
      $alert.addClass('out');
    }, 2000);

    setTimeout(function () {
      $alert.remove();
    }, 3000);
  }

  function trim(str) {
    return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
  }

  function addQuickPurchaseButton($item) {
    $item.find('.quick-add-to-cart').remove();

    var inventory = trim($item.find('.inventory').text()).toLowerCase();
    if (inventory === 'sold out') {
      console.log('item is sold out');
      return;
    }

    var $quickAddToCart = $("<div class='quick-add-to-cart' />")
    $quickAddToCart.on('click', function (e) {
      var title = trim($item.find('.content .h6').text());
      var id = $item.data('product-id');

      addToCart($(this), id, 1, title);

      e.preventDefault();
      e.stopPropagation();
    });

    $quickAddToCart.insertAfter($item.find('.content'));
  }

  /* When you're ready to use hi-res images, uncomment below. */
  window.fetchHiResCollectionImages = function () {
    $('.product-list-item').each(function () {
      var $img = $(this).find('img');
      var src = $img.data('hi-res');

      if (!src) { return true; }

      // setTimeout(function () {
        var img = new Image();
        img.onload = function () {
          $img.attr('src', src);
        };
        img.src = src
      // }, 3000);

      addQuickPurchaseButton($(this));
    });
  }

  setTimeout(function () {
    window.fetchHiResCollectionImages();
  }, 1000);

  if (window.App.touch) {
    $('body').addClass('touch-enabled');
  }

}());

